// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__igHAb","location":"Header_location__1ItRP"};